module.exports = __webpack_public_path__ + "static/media/04.4b4ea567.png";